export enum DistanceTargetType {
    POI = 'POI',
    CityCenter = 'cityCenter',
}
